import { render, staticRenderFns } from "./export_to_platform.vue?vue&type=template&id=7834187e&scoped=true&"
import script from "./export_to_platform.vue?vue&type=script&lang=js&"
export * from "./export_to_platform.vue?vue&type=script&lang=js&"
import style0 from "./export_to_platform.vue?vue&type=style&index=0&id=7834187e&prod&lang=scss&scoped=true&"
import style1 from "./export_to_platform.vue?vue&type=style&index=1&id=7834187e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7834187e",
  null
  
)

export default component.exports